var _defs, _ellipse, _ellipse2, _ellipse3, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _g2, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _polygon, _rect30, _rect31, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect32, _path9, _circle10, _path0, _path1, _path10, _path11, _path12, _g5, _path13, _path14, _g6, _path15, _g7, _g8, _path16, _path17, _rect33, _path18, _circle11, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g9, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect34, _rect35, _rect36, _circle12, _circle13, _circle14, _g0, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _polygon2, _path35, _path36, _path37, _path38, _path39, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _circle15, _circle16, _rect60, _rect61, _line14, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _circle17, _circle18, _rect68, _rect69, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect70, _circle19, _path49, _path50, _path51, _path52, _g1, _path53, _path54, _path55, _path56, _path57, _path58;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea98fdbc-a252-4665-af64-abf278d5674c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 891,
    height: 711.05,
    viewBox: "0 0 891 711.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9b3bd20d-94b1-4b89-8689-3658f931a37a",
    x1: 213.62,
    y1: 486,
    x2: 213.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3648b6f2-24b3-4612-9b51-2b94a6a7f037",
    x1: 227.62,
    y1: 373,
    x2: 227.62,
    y2: 362,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b464c917-b78b-4380-985f-dbae11a5e44a",
    x1: 227.62,
    y1: 429,
    x2: 227.62,
    y2: 418,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "72466b91-2539-4c80-b1ac-c07906bc8925",
    x1: 329.62,
    y1: 429,
    x2: 329.62,
    y2: 418,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "78890ed7-d917-4391-91b4-37ee3fc8ca06",
    x1: 336.62,
    y1: 83,
    x2: 336.62,
    y2: 72,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d0ac5340-3428-4a2e-9340-0c5bb4adc0ec",
    x1: 336.62,
    y1: 98,
    x2: 336.62,
    y2: 87,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7bf349c6-21a0-4377-b038-17309d0b4fe9",
    x1: 336.62,
    y1: 113,
    x2: 336.62,
    y2: 102,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "310c22dd-2978-41dd-b208-5581767f53d7",
    x1: 336.62,
    y1: 128,
    x2: 336.62,
    y2: 117,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9f8eec2a-ad59-4d16-9789-23c241b0441e",
    x1: 214.12,
    y1: 332,
    x2: 214.12,
    y2: 182,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f597f65b-8391-4099-8606-ddd6c1074545",
    x1: 383.9,
    y1: 435.3,
    x2: 383.9,
    y2: 283.3,
    gradientTransform: "translate(-5.78 0.18)",
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "536b70eb-a08e-4f57-b7a7-caae76ee659a",
    x1: 442.9,
    y1: 321.3,
    x2: 442.9,
    y2: 307.3,
    gradientTransform: "translate(-10.11 -4.98)",
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6a8945d3-e2ea-4790-bfb4-dc06924cb8b4",
    x1: 484.9,
    y1: 317.3,
    x2: 484.9,
    y2: 303.3,
    gradientTransform: "translate(-10.64 -8.78)",
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1fa4c350-6ac8-4471-a2c1-5350628064fb",
    x1: 547.96,
    y1: 413.42,
    x2: 547.96,
    y2: 413.16,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4c1eb33a-694b-43df-a00c-843591e6cad6",
    x1: 517.63,
    y1: 581.29,
    x2: 517.63,
    y2: 408.48,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dca23823-ed36-4339-a791-14813e0bdcff",
    x1: 191.31,
    y1: 423.33,
    x2: 191.31,
    y2: 423.02,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "88a18300-a7c9-44fe-be2f-c3664a6015d6",
    x1: 228.23,
    y1: 619.83,
    x2: 228.23,
    y2: 417.36,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9a3d7bb1-47c0-4ca8-a076-fba8f746a389",
    x1: 692,
    y1: 659.05,
    x2: 692,
    y2: 163.05,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "89aca64f-6823-4107-b0e5-363f57c50e19",
    x1: 595.12,
    y1: 395.68,
    x2: 595.12,
    y2: 241.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "244838b0-6b94-4a4f-974c-f4ebcd2d6e43",
    x1: 788.12,
    y1: 472.68,
    x2: 788.12,
    y2: 318.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a95129aa-3a9b-452b-80f4-39c8b969ae6a",
    x1: 696.12,
    y1: 614.68,
    x2: 696.12,
    y2: 508.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "09992bb0-0588-4d4c-95c8-1ad271d94435",
    x1: 749.12,
    y1: 475.15,
    x2: 749.12,
    y2: 351.15,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e976fbab-c7be-4f98-b33a-a56658b85843",
    x1: 790.62,
    y1: 362.68,
    x2: 790.62,
    y2: 344.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "294b6eda-21ba-4cef-8333-d7c4aaac1d9e",
    x1: 760.62,
    y1: 699.68,
    x2: 760.62,
    y2: 677.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "065b80c5-77d7-4835-9968-dbf0ab7011d1",
    x1: 607.62,
    y1: 687.68,
    x2: 607.62,
    y2: 566.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2a3369eb-9ffa-44ee-b4f3-0d72059a1e3a",
    x1: 608.62,
    y1: 648.68,
    x2: 608.62,
    y2: 648.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "327d5fd3-480a-4895-a6c0-ce7eb7e65eff",
    x1: 482.12,
    y1: 645.68,
    x2: 482.12,
    y2: 590.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "47ebed85-0f1a-4564-9c94-c36bbc13acdd",
    x1: 459.62,
    y1: 699.68,
    x2: 459.62,
    y2: 677.68,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2b699f83-9fbb-4b6d-8a24-a3f0d4476570",
    x1: 486.35,
    y1: 708.79,
    x2: 600.65,
    y2: 708.79,
    xlinkHref: "#9b3bd20d-94b1-4b89-8689-3658f931a37a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 694.05,
    rx: 67,
    ry: 17,
    fill: "#f2f2f2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 506.05,
    rx: 67,
    ry: 17,
    fill: "#f2f2f2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67,
    cy: 514.05,
    rx: 67,
    ry: 17,
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.62,
    y: 4,
    width: 383,
    height: 14.5,
    fill: "#f5f5f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.62,
    width: 396,
    height: 486,
    fill: "url(#9b3bd20d-94b1-4b89-8689-3658f931a37a)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.62,
    y: 18.5,
    width: 383,
    height: 459.5,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 11.5,
    r: 3.5,
    fill: "#ff5252"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.12,
    cy: 11.5,
    r: 3.5,
    fill: "#ff0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.75,
    cy: 11.5,
    r: 3.5,
    fill: "#69f0ae"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.62,
    y: 36,
    width: 149,
    height: 9,
    fill: "#6415ff"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 139.62,
    y: 73,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.62,
    y: 363,
    width: 149,
    height: 9,
    fill: "#6415ff",
    opacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 362,
    width: 50,
    height: 11,
    fill: "url(#3648b6f2-24b3-4612-9b51-2b94a6a7f037)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 418,
    width: 50,
    height: 11,
    fill: "url(#b464c917-b78b-4380-985f-dbae11a5e44a)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 304.62,
    y: 418,
    width: 50,
    height: 11,
    fill: "url(#72466b91-2539-4c80-b1ac-c07906bc8925)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.62,
    y: 363,
    width: 47,
    height: 9,
    fill: "#6415ff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 204.62,
    y: 419,
    width: 47,
    height: 9,
    fill: "#6415ff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 305.62,
    y: 419,
    width: 47,
    height: 9,
    fill: "#6415ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33.62,
    y: 391,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 204.62,
    y: 391,
    width: 149,
    height: 9,
    fill: "#6415ff",
    opacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 204.62,
    y: 447,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 33.62,
    y: 419,
    width: 149,
    height: 9,
    fill: "#6415ff",
    opacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33.62,
    y: 447,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 139.62,
    y: 88,
    width: 84,
    height: 9,
    fill: "#f5f5f5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 238.62,
    y: 88,
    width: 29,
    height: 9,
    fill: "#f5f5f5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 139.62,
    y: 118,
    width: 84,
    height: 9,
    fill: "#f5f5f5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 238.62,
    y: 118,
    width: 29,
    height: 9,
    fill: "#f5f5f5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 139.62,
    y: 103,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.62,
    y: 36,
    width: 149,
    height: 9,
    fill: "#6415ff"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 327.62,
    y: 72,
    width: 18,
    height: 11,
    fill: "url(#78890ed7-d917-4391-91b4-37ee3fc8ca06)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 327.62,
    y: 87,
    width: 18,
    height: 11,
    fill: "url(#d0ac5340-3428-4a2e-9340-0c5bb4adc0ec)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 327.62,
    y: 102,
    width: 18,
    height: 11,
    fill: "url(#7bf349c6-21a0-4377-b038-17309d0b4fe9)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 328.62,
    y: 73,
    width: 16,
    height: 9,
    fill: "#ff5252"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 328.62,
    y: 88,
    width: 16,
    height: 9,
    fill: "#ff9800"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 328.62,
    y: 103,
    width: 16,
    height: 9,
    fill: "#69f0ae"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 327.62,
    y: 117,
    width: 18,
    height: 11,
    fill: "url(#310c22dd-2978-41dd-b208-5581767f53d7)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 328.62,
    y: 118,
    width: 16,
    height: 9,
    fill: "#6415ff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 30.62,
    y: 182,
    width: 367,
    height: 150,
    fill: "url(#9f8eec2a-ad59-4d16-9789-23c241b0441e)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 33.62,
    y: 185,
    width: 359,
    height: 142,
    fill: "#6415ff",
    opacity: 0.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "44.62 196 392.62 196 392.62 185 33.62 185 33.62 327 44.62 327 44.62 196",
    fill: "#fff",
    opacity: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 193.12,
    y: 283.48,
    width: 370,
    height: 152,
    transform: "translate(-185.54 -58.7) rotate(-5.2)",
    fill: "url(#f597f65b-8391-4099-8606-ddd6c1074545)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 199.03,
    y: 287.43,
    width: 359,
    height: 142,
    transform: "translate(-185.45 -58.67) rotate(-5.2)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220,420.07,213.8,341.3s32-34,96.6-8.8,95.06,7.41,105.56-9.61,65-36,82.66-7.53,38.84-3.54,38.84-3.54l7.16,78.67Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#6415ff",
    opacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 98.03,
    y1: 229.66,
    x2: 98.57,
    y2: 235.64,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 99.62,
    y1: 247.1,
    x2: 105.36,
    y2: 310.16,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10,
    strokeDasharray: "11.51 11.51"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 105.88,
    y1: 315.89,
    x2: 106.43,
    y2: 321.86,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 159.52,
    y1: 239.42,
    x2: 160.07,
    y2: 245.39,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 161.25,
    y1: 258.4,
    x2: 165.4,
    y2: 303.91,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10,
    strokeDasharray: "13.06 13.06"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 165.99,
    y1: 310.41,
    x2: 166.53,
    y2: 316.39,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 222.26,
    y1: 250.1,
    x2: 222.86,
    y2: 256.07,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 223.83,
    y1: 265.82,
    x2: 227.21,
    y2: 299.92,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10,
    strokeDasharray: "9.79 9.79"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 227.7,
    y1: 304.79,
    x2: 228.29,
    y2: 310.77,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 278.65,
    y1: 214.84,
    x2: 279.19,
    y2: 220.82,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 280.21,
    y1: 232.05,
    x2: 285.84,
    y2: 293.84,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10,
    strokeDasharray: "11.28 11.28"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 286.35,
    y1: 299.45,
    x2: 286.9,
    y2: 305.43,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 319.35,
    y1: 206.59,
    x2: 319.89,
    y2: 212.56,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 320.97,
    y1: 224.44,
    x2: 326.92,
    y2: 289.77,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10,
    strokeDasharray: "11.93 11.93"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 327.46,
    y1: 295.71,
    x2: 328.01,
    y2: 301.68,
    fill: "none",
    stroke: "#6415ff",
    strokeMiterlimit: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.36,
    cy: 323.73,
    r: 5,
    transform: "translate(-182.82 -70.25) rotate(-5.2)",
    fill: "#ff9800"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.56,
    cy: 334.23,
    r: 5,
    transform: "translate(-183.52 -64.66) rotate(-5.2)",
    fill: "#ff5252"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.76,
    cy: 344.54,
    r: 5,
    transform: "translate(-184.19 -58.89) rotate(-5.2)",
    fill: "#69f0ae"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.8,
    cy: 309.31,
    r: 7,
    transform: "translate(-180.77 -53.95) rotate(-5.2)",
    fill: "url(#536b70eb-a08e-4f57-b7a7-caae76ee659a)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.26,
    cy: 301.52,
    r: 7,
    transform: "translate(-179.89 -50.22) rotate(-5.2)",
    fill: "url(#6a8945d3-e2ea-4790-bfb4-dc06924cb8b4)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.8,
    cy: 309.31,
    r: 5,
    transform: "translate(-180.77 -53.95) rotate(-5.2)",
    fill: "#6415ff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.26,
    cy: 301.52,
    r: 5,
    transform: "translate(-179.89 -50.22) rotate(-5.2)",
    fill: "#6415ff"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.64,
    cy: 313.82,
    r: 5,
    transform: "translate(-180.75 -44.42) rotate(-5.2)",
    fill: "#69f0ae"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.76,413.2l.07.23C548.6,413,547.76,413.2,547.76,413.2Z",
    transform: "translate(-154.5 -94.48)",
    fill: "url(#1fa4c350-6ac8-4471-a2c1-5350628064fb)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.48,581.18l16.28-2.63-2.24-10h0l0-.14h-.06l-11.54-53V476.76a14.26,14.26,0,0,0-.08-1.47c17.24-22.86,7-58.73,6-61.86-.18.09-.45.21-.83.36a21.06,21.06,0,0,0-.79-4.13s-5-3.18-7.73.91c-2.38,3.57-.61,5.75-.12,6.26l-.34.11a11.52,11.52,0,0,1,1.58,3.94,8.65,8.65,0,0,0-.54-1c-.63-.11-1-.21-1-.21l-.12-.11-.34.11c1.73,2.53,2.34,7,2.26,12.3a17.36,17.36,0,0,0-2-2.31,17.65,17.65,0,0,0-11.7-4.88h-.83q-.68,0-1.36.09l-.34,0-.57.08-.65.12-.47.1-.81.22-.3.09c-.34.11-.67.22-1,.35a17.24,17.24,0,0,1-3.43,1.24c-.16,0-.32,0-.49.05h0a5.72,5.72,0,0,1-3.75-1.07l-.36-.28a5.29,5.29,0,0,1-.39-.37,2.54,2.54,0,0,0-.17,1.09,3.35,3.35,0,0,0,1.17,2.27,3.17,3.17,0,0,0,.62.42,2.68,2.68,0,0,0,1.06.3h.38l-.09,0c-.23.11-.46.21-.7.3l-.05,0c-.26.09-.51.17-.78.24h0a8.68,8.68,0,0,1-4,.06h0l-.43-.1c-.21-.06-.43-.12-.63-.19a4.8,4.8,0,0,0,.22.44l.08.13.18.28.11.14.2.25.12.13.25.25.1.09.37.31.13.09.27.19.18.11.24.14.2.1.25.11.21.09.28.1.35.1.26.07.25,0,.23,0,.26,0h1a5,5,0,0,0,1.5-.37l-.92.38h0l-.46.16-.47.17-.47.14-.48.14-.47.12-.5.12-.46.09-.53.09-.44.07-.57.07-.41,0-.65,0-.34,0h-1a4.21,4.21,0,0,1,1.51.8,4,4,0,0,0,.93.5,3.59,3.59,0,0,0,.45.1l.13,0,.32,0h1.35l.44,0a6.54,6.54,0,0,1,2.59.83,4.65,4.65,0,0,1,1.11,1c-.14.23-.28.45-.4.69s-.21.4-.31.61q-.3.62-.53,1.27a14.08,14.08,0,0,0-.86,4.85c0,.31,0,.61,0,.91,0,.08,0,.17,0,.25q0,.36.08.72l0,.19q.06.44.16.87l0,.17q.08.36.18.71l.06.21a14,14,0,0,0,.61,1.66l.07.16q.17.37.35.72l0,.07q.22.4.46.79l0,.06q.22.36.47.7l.06.08a14.17,14.17,0,0,0,1.17,1.41l0,0a14.14,14.14,0,0,0,3.77,2.83,6.3,6.3,0,0,0-.11.65h0a6.36,6.36,0,0,0,0,.68v5.28q-.45.24-.88.51c-12.53-5.69-31.19-46-31.19-46h-.45c1.82-1.36,0-7.28,0-7.28a8.54,8.54,0,0,0-3.5-1.16h-1l-.18,0-.13,0-.18,0-.12,0-.2.06-.1,0-.3.11h0l-.28.13-.1.05-.19.11L482,411l-.18.12-.11.09-.17.14-.11.1-.17.16-.1.11-.17.2-.08.1-.25.34c-2.73,4.09,0,6.37,0,6.37a40.74,40.74,0,0,0-.25,4.75c-.2,29.46,31.33,52.29,32.94,53.43-.71,1.84-6.57,18.14.07,38.49a.65.65,0,0,0,.08.14,59.08,59.08,0,0,0-17.72,55.88l.13.61h.29a4,4,0,0,1-.11.4,4.59,4.59,0,0,1-.29.7,5.43,5.43,0,0,1-.73,1.07l0,0c-.31.36-.67.72-1.05,1.09l-.4.38c-1.59,1.52-3.2,3-2,3.6h17.21v-7.51h.3s-.12-.23-.3-.68V571h-.06c-.9-2.32-3-9.5.36-20.56,4.09-13.65,20-20.47,20-20.47l.29,1-.06,0,12.48,41c0,.16,0,.32-.05.49a6.67,6.67,0,0,1-.27,1.14,7.25,7.25,0,0,1-.34.84c-.77,1.59-2.1,3.46-2.68,4.86a4.71,4.71,0,0,0-.21.59,1.82,1.82,0,0,0-.07.7.81.81,0,0,0,.53.67h0l.23,0,.48-.08Zm-4.82-116.73q-.47-.26-1-.49V459a6.32,6.32,0,0,0-.11-1.13,14.11,14.11,0,0,0,3-1.93C535.95,459,535.28,461.93,534.67,464.45Z",
    transform: "translate(-154.5 -94.48)",
    fill: "url(#4c1eb33a-694b-43df-a00c-843591e6cad6)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.38,423.09s-3-2.52,0-7.06,8.57-1,8.57-1,2,6.55,0,8.06S480.38,423.09,480.38,423.09Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ca7070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "cbb1ca8a-3a06-4d8d-9881-c3637d2b9b50",
    "data-name": "<Path>",
    d: "M511.54,591.75H497.65a4.56,4.56,0,0,1-1.31,3.57c-1.87,2.16-5.63,4.77-3.86,5.66h19.06Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#00695c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M497.35,595.32a4.56,4.56,0,0,0,1.31-3.57h-1a4.56,4.56,0,0,1-1.31,3.57c-1.87,2.16-5.63,4.77-3.86,5.66h1C491.72,600.09,495.48,597.49,497.35,595.32Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "ec846da8-b8c9-4838-98ee-b96510078eab",
    "data-name": "<Path>",
    d: "M561,588.89,548,591a6.62,6.62,0,0,1-.59,4.58c-1.42,3-4.61,6.74-2.69,7.55l18.82-3Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#00695c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M554.66,416.94s14.87,46.91-10.07,72.88l-7.2-5.51s14.74-51.2,6.49-63.22C558.44,416.24,554.66,416.94,554.66,416.94Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#00695c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M544.38,421.08s-3-2.52,0-7.06,8.57-1,8.57-1,2,6.55,0,8.06S544.38,421.08,544.38,421.08Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ca7070"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M548.41,595.59A6.62,6.62,0,0,0,549,591L561,589l0-.16L548,591a6.62,6.62,0,0,1-.59,4.58c-1.42,3-4.61,6.74-2.69,7.55l.79-.13C544.08,602,547.05,598.41,548.41,595.59Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 370.48,
    y: 366.16,
    width: 14.11,
    height: 20.91,
    rx: 7.06,
    ry: 7.06,
    fill: "#ca7070"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M538.4,487.33s14.56-50.57,6.63-63c-.7-.13-1.15-.23-1.15-.23l-.13-.12-.37.12c8.25,12-6.49,63.22-6.49,63.22l7.2,5.51.63-.68Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 377.79,
    cy: 357.85,
    r: 15.62,
    fill: "#ca7070"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M526.74,474.5v-6.8a7,7,0,0,1,.16-1.48,15.62,15.62,0,0,1,6.26-29.49l-.88,0a15.62,15.62,0,0,0-7.15,29.51,7,7,0,0,0-.16,1.48v6.8a7,7,0,0,0,7.94,7A7.08,7.08,0,0,1,526.74,474.5Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M548.16,530.18s-30.13,3.4-31.24,0c-7.81-23.94,0-42.83,0-42.83a15.62,15.62,0,0,1,15.62-15.62h0a15.62,15.62,0,0,1,15.62,15.62Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#00695c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M548.16,530.18l13.61,62.49H548.16l-14.11-46.36s-17.64,7.56-22.17,22.68,0,23.68,0,23.68H497.26l-.15-.68a65,65,0,0,1,19.8-61.81h0",
    transform: "translate(-154.5 -94.48)",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M518.68,530.18c-7.81-23.94,0-42.83,0-42.83a15.62,15.62,0,0,1,14.61-15.59c-.33,0-.67,0-1,0h0a15.62,15.62,0,0,0-15.62,15.62s-7.81,18.9,0,42.83c.4,1.22,4.52,1.56,9.64,1.51C522.15,531.63,519,531.23,518.68,530.18Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M516.67,487.09s-40.31-28.22-36.28-64h9.07S511.12,470,525,474.5,516.67,487.09,516.67,487.09Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#00695c"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.31,547.41l13.85,45.51h2l-14.11-46.36S535.4,546.84,534.31,547.41Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.93,530.43h-2a65,65,0,0,0-19.8,61.81l.15.68h2l-.15-.68A65,65,0,0,1,518.93,530.43Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M481.9,423.6h-1.51c-4,35.78,36.28,64,36.28,64l1-.38C513,483.77,478.13,457,481.9,423.6Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M519.83,445.35a25.85,25.85,0,0,1,1.82,6.29c1,4.38,3.26,8.75,7.15,11a15.87,15.87,0,0,0,7,1.91c3.72.23,7.75-.49,10.38-3.13a12.86,12.86,0,0,0,3.17-6.39,21.63,21.63,0,0,0-5.69-19.88,19.19,19.19,0,0,0-20-4.19,19.1,19.1,0,0,1-3.79,1.38,6.31,6.31,0,0,1-5.53-1.84,3.49,3.49,0,0,0,3.37,4.52,9.73,9.73,0,0,1-7.46.4,6.33,6.33,0,0,0,8,3.19,21.32,21.32,0,0,1-9,1.84c.65,0,1.92,1.2,2.71,1.44a17.18,17.18,0,0,0,3,.21A5.82,5.82,0,0,1,519.83,445.35Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#263238"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.75,435a9.63,9.63,0,0,1-3.7.95,9.7,9.7,0,0,0,4.71-.95,3.53,3.53,0,0,1-3.54-3.81,5.94,5.94,0,0,1-.84-.71A3.49,3.49,0,0,0,517.75,435Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.91,432.35a19.1,19.1,0,0,0,3.79-1.38,17.38,17.38,0,0,1,6-1.21,17.56,17.56,0,0,0-7,1.21,19.1,19.1,0,0,1-3.79,1.38c-.18,0-.36,0-.54.06A6,6,0,0,0,520.91,432.35Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.92,441.9c-.79-.23-2.06-1.42-2.71-1.44a21.32,21.32,0,0,0,9-1.84,5.58,5.58,0,0,1-2,.42,21.33,21.33,0,0,1-8,1.42c.65,0,1.92,1.2,2.71,1.44a6.71,6.71,0,0,0,2.1.17A4.38,4.38,0,0,1,512.92,441.9Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.83,464.56a15.87,15.87,0,0,1-7-1.91c-3.89-2.27-6.11-6.64-7.15-11a25.85,25.85,0,0,0-1.82-6.29,5.82,5.82,0,0,0-4.93-3.23,10.07,10.07,0,0,0-1.5,0l.49,0a5.82,5.82,0,0,1,4.93,3.23,25.85,25.85,0,0,1,1.82,6.29c1,4.38,3.26,8.75,7.15,11a15.87,15.87,0,0,0,7,1.91c.58,0,1.16,0,1.75,0Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.58,439a6.38,6.38,0,0,1-5.12-3.27,9.32,9.32,0,0,1-1.17-.33A6.38,6.38,0,0,0,516.58,439Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M481.39,423.09s-3-2.52,0-7.06a4.83,4.83,0,0,1,3.74-2.29,4.9,4.9,0,0,0-4.74,2.29c-3,4.54,0,7.06,0,7.06a27.32,27.32,0,0,0,5.93.66A29.83,29.83,0,0,1,481.39,423.09Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.47,423.33l.08-.27S190.53,422.86,191.47,423.33Z",
    transform: "translate(-154.5 -94.48)",
    fill: "url(#dca23823-ed36-4339-a791-14813e0bdcff)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.7,440.09a6.59,6.59,0,0,0-.36-.93c0-.1-.1-.18-.15-.27a5.61,5.61,0,0,0-.3-.52l-.2-.26a5.06,5.06,0,0,0-.33-.39l-.23-.23c-.12-.11-.24-.21-.36-.3l-.25-.18-.4-.24-.25-.13-.45-.19-.23-.09q-.32-.11-.65-.18h0a10.33,10.33,0,0,0-4.39.12s-4.19,6.18-2.58,8.4l-.53-.16s-31.13,34.74-48.69,41.19q-.67-.46-1.39-.86v-6.5a7.67,7.67,0,0,0,0-.82v0a7.6,7.6,0,0,0-.13-.77l.13-.07.52-.29.75-.46.48-.31q.54-.37,1-.78l.39-.34c.24-.2.47-.41.69-.63l.4-.39q.42-.43.8-.88l.28-.34q.36-.45.69-.92l.28-.42q.3-.46.57-.94l.18-.31c.22-.41.43-.84.61-1.28l.16-.39q.21-.53.39-1.07c0-.13.09-.25.12-.38.14-.47.27-.94.37-1.43,0-.1,0-.19.05-.29q.12-.61.19-1.24c0-.14,0-.28,0-.42,0-.51.08-1,.08-1.55a17,17,0,0,0-3.78-10.69c1.33-2.08,2.2-3.31,2.2-3.31-.8-.55-1.59-1.05-2.37-1.54l-.76-.45c-.52-.31-1-.62-1.56-.9l-.87-.46c-.47-.25-.93-.49-1.39-.71l-.89-.41-1.33-.58-.87-.35c-.44-.17-.88-.33-1.31-.48l-.82-.28c-.45-.14-.9-.27-1.34-.39l-.73-.2c-.5-.12-1-.22-1.49-.32l-.53-.11c-.67-.12-1.33-.21-2-.27h0a23.71,23.71,0,0,0-12,1.84c.2-4.78,1-8.72,2.68-11.16l-.41-.14-.14.14s-.49.11-1.26.25a10.44,10.44,0,0,0-.65,1.21,13.91,13.91,0,0,1,1.91-4.76l-.41-.14c.59-.61,2.73-3.24-.14-7.55-3.3-4.94-9.34-1.1-9.34-1.1a25.56,25.56,0,0,0-.94,5c-.46-.19-.79-.33-1-.44a124.5,124.5,0,0,0-4.69,31.36c-10.89,15.46-15.39,38.28-16.27,43.2h0l-.07.39v0c-.06.36-.09.55-.09.55l28.31.66c0,.1,0,.19,0,.29v44.83L178,588.22s7.84.25,19.64,1.76l-3.26,23.31h0l-1.09,6.54h19.62c2.18-4.36-8.72-6.54-8.72-6.54h-.24l4.25-21.75q2.82.47,5.8,1a56.81,56.81,0,0,0,8.83,1h0a46.94,46.94,0,0,0,7.35-.32c1.44,11.79-.45,18.83-.81,20h-.11l-1.09,6.54h19.62c1.9-3.8-6.14-5.95-8.23-6.43l.09-.64a109.41,109.41,0,0,0,.77-22.2,26.87,26.87,0,0,0,7-4.17l0,0,.27-.24,0,0,.08-.08-14.61-41c2.73-11.6-6.77-23.78-1.7-29.87s2-13.86,1.4-15.19c13.72-6,41.45-21,49.23-47a49.17,49.17,0,0,0,1.39-5.57S287.4,445.78,285.7,440.09Z",
    transform: "translate(-154.5 -94.48)",
    fill: "url(#88a18300-a7c9-44fe-be2f-c3664a6015d6)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.58,430.94s-14.87,46.91,10.07,72.88l7.2-5.51s-14.74-51.2-6.49-63.22C190.8,430.24,194.58,430.94,194.58,430.94Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ff5252"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.86,435.08s3-2.52,0-7.06-8.57-1-8.57-1-2,6.55,0,8.06S204.86,435.08,204.86,435.08Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#f6b9ad"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 210.15,
    y: 474.64,
    width: 14.11,
    height: 20.91,
    rx: 7.06,
    ry: 7.06,
    transform: "translate(279.91 875.71) rotate(180)",
    fill: "#f6b9ad"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M210.84,501.33s-14.56-50.57-6.63-63c.7-.13,1.15-.23,1.15-.23l.13-.12.37.12c-8.25,12,6.49,63.22,6.49,63.22l-7.2,5.51-.63-.68Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.45,
    cy: 371.85,
    r: 15.62,
    fill: "#f6b9ad"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5,488.5v-6.8a7,7,0,0,0-.16-1.48,15.62,15.62,0,0,0-6.26-29.49l.88,0a15.62,15.62,0,0,1,7.15,29.51,7,7,0,0,1,.16,1.48v6.8a7,7,0,0,1-7.94,7A7.08,7.08,0,0,0,222.5,488.5Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.08,544.18s30.13,3.4,31.24,0c3.6-11-6-22.89-1.2-28.7,5-6,1.2-14.13,1.2-14.13a15.62,15.62,0,0,0-15.62-15.62h0a15.62,15.62,0,0,0-15.62,15.62Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ff5252"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231.16,515.48c5-6,1.2-14.13,1.2-14.13a15.62,15.62,0,0,0-15.62-15.62c-.34,0-.67,0-1,.05a15.61,15.61,0,0,1,14.62,15.57s3.8,8.13-1.2,14.13c-4.84,5.81,4.8,17.69,1.2,28.7-.34,1.05-3.45,1.45-7.58,1.51,5.09.05,9.19-.29,9.58-1.51C236,533.16,226.32,521.29,231.16,515.48Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M225.93,543.18h0c11,15.59,15.87,39.15,12.72,61.81l-.09.68h-9.39s2.91-8.57,0-23.68a37.39,37.39,0,0,0-14.24-22.68l-9.06,46.36h-8.74l8.74-62.49Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#f6b9ad"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M278.89,453.31s3.63-1.52,2.07-6.75-7.9-3.47-7.9-3.47-3.85,5.67-2.36,7.71S278.89,453.31,278.89,453.31Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#f6b9ad"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.44,503.87s46.81-15.17,53.44-50.56l-8.67-2.66s-34.45,38.46-49,38.73S225.44,503.87,225.44,503.87Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ff5252"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M277.29,453.35l1.45.44c-6.63,35.39-53.44,50.56-53.44,50.56l-.83-.65C230,501.78,271.11,486.36,277.29,453.35Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.92,559.31l-9.06,46.36h2l8.8-45A21.63,21.63,0,0,0,212.92,559.31Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,543.18h-2c11,15.59,15.87,39.15,12.72,61.81l-.09.68h2l.09-.68C241.8,582.33,236.95,558.77,225.93,543.18Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M277.92,453s3.63-1.52,2.07-6.75a4.83,4.83,0,0,0-2.9-3.29,4.9,4.9,0,0,1,3.86,3.58c1.56,5.22-2.07,6.75-2.07,6.75a27.32,27.32,0,0,1-5.86-1.1A29.83,29.83,0,0,0,277.92,453Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.08,542.48l-19,40a235,235,0,0,1,33,4c21,4,31-6,31-6l-13.55-38Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M206.12,605.48s10,2,8,6h-18l1-6Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ff5252"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.12,605.48s10,2,8,6h-18l1-6Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ff5252"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M231.12,453.48s-24,34-13,48l-43-1S187.12,423.48,231.12,453.48Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fccc63"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M231.12,453.48c-6.2-4.23-11.76-6.33-16.75-6.82a42.33,42.33,0,0,1,11.75,5.82s-24,34-13,48l-37.85-.88c-.1.57-.15.88-.15.88l43,1C207.12,487.48,231.12,453.48,231.12,453.48Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M232.58,542.48h-3l13.55,38s-6.46,6.45-19.9,6.91c15.47.5,22.9-6.91,22.9-6.91Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M206.12,605.48h-2s10,2,8,6h2C216.12,607.48,206.12,605.48,206.12,605.48Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M238.12,605.48h-2s10,2,8,6h2C248.12,607.48,238.12,605.48,238.12,605.48Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 500.62,
    y: 167.68,
    width: 383,
    height: 14.5,
    fill: "#f5f5f5"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 493,
    y: 163.05,
    width: 398,
    height: 496,
    fill: "url(#9a3d7bb1-47c0-4ca8-a076-fba8f746a389)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 500.62,
    y: 182.18,
    width: 383,
    height: 459.5,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.5,
    cy: 175.18,
    r: 3.5,
    fill: "#ff5252"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.12,
    cy: 175.18,
    r: 3.5,
    fill: "#ff0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.75,
    cy: 175.18,
    r: 3.5,
    fill: "#69f0ae"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.62,
    y: 202.68,
    width: 336,
    height: 9,
    fill: "#6415ff"
  }))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 522.62,
    y: 241.68,
    width: 145,
    height: 154,
    fill: "url(#89aca64f-6823-4107-b0e5-363f57c50e19)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 525.62,
    y: 246.68,
    width: 139,
    height: 144,
    fill: "#fff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 715.62,
    y: 318.68,
    width: 145,
    height: 154,
    fill: "url(#244838b0-6b94-4a4f-974c-f4ebcd2d6e43)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 718.62,
    y: 323.68,
    width: 139,
    height: 144,
    fill: "#fff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 525.62,
    y: 508.68,
    width: 341,
    height: 106,
    fill: "url(#a95129aa-3a9b-452b-80f4-39c8b969ae6a)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 532.62,
    y: 515.68,
    width: 328,
    height: 95,
    fill: "#6415ff",
    opacity: 0.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "540.62 524.68 860.62 524.68 860.62 515.68 532.62 515.68 532.62 610.68 540.62 610.68 540.62 524.68",
    fill: "#fff",
    opacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M796.09,372.71a62,62,0,1,0,15,40.45A61.84,61.84,0,0,0,796.09,372.71Zm-25,77.47a43,43,0,1,1,21.08-37A42.81,42.81,0,0,1,771.12,450.18Z",
    transform: "translate(-154.5 -94.48)",
    fill: "url(#09992bb0-0588-4d4c-95c8-1ad271d94435)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M780.17,386.42l13.65-11.75a58.85,58.85,0,0,0-44.7-20.51v18A40.91,40.91,0,0,1,780.17,386.42Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ff5252"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M749.12,454.15a40.74,40.74,0,0,1-16.92-3.67l-7.43,16.41a59,59,0,0,0,54.49-3l-9.2-15.49A40.74,40.74,0,0,1,749.12,454.15Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#69f0ae"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M808.12,413.15a58.75,58.75,0,0,0-14.3-38.49l-13.65,11.75a40.93,40.93,0,0,1-10.11,62l9.2,15.49A59,59,0,0,0,808.12,413.15Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#ff9800"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M708.12,413.15a41,41,0,0,1,41-41v-18a59,59,0,0,0-24.35,112.74l7.43-16.41A41,41,0,0,1,708.12,413.15Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#6415ff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 737.62,
    y: 344.68,
    width: 106,
    height: 18,
    fill: "url(#e976fbab-c7be-4f98-b33a-a56658b85843)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 738.62,
    y: 345.68,
    width: 104,
    height: 16,
    fill: "#6415ff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 738.62,
    y: 372.68,
    width: 76,
    height: 16,
    fill: "#ff5252"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 738.62,
    y: 399.68,
    width: 52,
    height: 16,
    fill: "#69f0ae"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 738.62,
    y: 426.68,
    width: 94,
    height: 16,
    fill: "#ff9800"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 525.62,
    y: 419.68,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 525.62,
    y: 434.68,
    width: 84,
    height: 9,
    fill: "#f5f5f5"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 624.62,
    y: 434.68,
    width: 29,
    height: 9,
    fill: "#f5f5f5"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 624.62,
    y: 467.68,
    width: 29,
    height: 9,
    fill: "#f5f5f5"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 525.62,
    y: 464.68,
    width: 84,
    height: 9,
    fill: "#f5f5f5"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 525.62,
    y: 449.68,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 713.62,
    y: 242.68,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 713.62,
    y: 257.68,
    width: 84,
    height: 9,
    fill: "#f5f5f5"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 812.62,
    y: 257.68,
    width: 29,
    height: 9,
    fill: "#f5f5f5"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 812.62,
    y: 290.68,
    width: 29,
    height: 9,
    fill: "#f5f5f5"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 713.62,
    y: 287.68,
    width: 84,
    height: 9,
    fill: "#f5f5f5"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 713.62,
    y: 272.68,
    width: 149,
    height: 9,
    fill: "#f5f5f5"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.62,
    cy: 688.68,
    r: 11,
    fill: "url(#294b6eda-21ba-4cef-8333-d7c4aaac1d9e)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.62,
    cy: 688.68,
    r: 8,
    fill: "#ff5252"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 435.62,
    y: 566.68,
    width: 344,
    height: 121,
    fill: "url(#065b80c5-77d7-4835-9968-dbf0ab7011d1)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 445.62,
    y: 571.68,
    width: 328,
    height: 95,
    fill: "#fff"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 456.62,
    y1: 648.68,
    x2: 760.62,
    y2: 648.68,
    stroke: "#6415ff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    fill: "url(#2a3369eb-9ffa-44ee-b4f3-0d72059a1e3a)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 459.62,
    y: 590.68,
    width: 45,
    height: 55,
    fill: "url(#327d5fd3-480a-4895-a6c0-ce7eb7e65eff)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 462.12,
    y: 593.18,
    width: 40,
    height: 51,
    fill: "#6415ff"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 712.62,
    y: 629.68,
    width: 40,
    height: 16,
    fill: "#69f0ae"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 637.62,
    y: 608.68,
    width: 40,
    height: 36,
    fill: "#ff9800"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 549.62,
    y: 614.68,
    width: 40,
    height: 30,
    fill: "#ff5252"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 445.62,
    y: 666.68,
    width: 328,
    height: 14,
    fill: "#ff5252"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.62,
    cy: 688.68,
    r: 11,
    fill: "url(#47ebed85-0f1a-4564-9c94-c36bbc13acdd)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.62,
    cy: 688.68,
    r: 8,
    fill: "#ff5252"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 437.62,
    y: 575.68,
    width: 8,
    height: 105,
    fill: "#ff5252"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 437.62,
    y: 575.68,
    width: 8,
    height: 105,
    opacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M600.65,681.32c0-.11,0-.21,0-.32s0-.33,0-.49,0-.21-.06-.31-.07-.3-.12-.44-.06-.19-.1-.29-.12-.28-.18-.42l-.12-.25c-.08-.14-.17-.28-.26-.41l-.13-.19a6.62,6.62,0,0,0-.42-.52l0,0h0a9.62,9.62,0,0,0-2.79-2.06,8.05,8.05,0,0,0,1.79-3.08,6.42,6.42,0,0,0,.24-.94c0-.1,0-.2,0-.29a5.46,5.46,0,0,0,.05-.58c0-.11,0-.21,0-.32s0-.33,0-.49,0-.21-.06-.31-.07-.3-.12-.44-.06-.19-.1-.29-.12-.28-.18-.42l-.12-.25c-.08-.14-.17-.28-.26-.41l-.13-.19a6.62,6.62,0,0,0-.42-.52l0,0h0a10.07,10.07,0,0,0-3.55-2.4s-6.35,2.35-6.77,4.93c-4.66,1-31.82,6.65-50.47,6.2l-.14-.37a16.59,16.59,0,0,0-8.83-14.67V654.5a7.48,7.48,0,0,0,0-.8v0a7.41,7.41,0,0,0-.12-.76l.12-.07.51-.28.74-.45.47-.31q.52-.36,1-.76l.38-.33c.23-.2.45-.4.67-.61l.39-.38q.41-.42.78-.86l.27-.34q.35-.44.67-.9l.27-.41q.29-.45.56-.92l.17-.3c.22-.4.42-.82.6-1.24l.15-.38q.21-.51.38-1l.12-.37c.14-.46.26-.92.36-1.39,0-.09,0-.19.05-.28q.11-.6.18-1.21c0-.14,0-.27,0-.41,0-.5.08-1,.08-1.51a16.51,16.51,0,0,0-2.13-8.11c1.07-.26,1.72-.47,1.64-.57-.41-.55-.82-1.07-1.25-1.57l-.41-.47c-.3-.34-.59-.66-.89-1l-.48-.49c-.3-.3-.6-.58-.9-.85l-.47-.42c-.38-.32-.76-.63-1.14-.93l-.25-.2c-.46-.34-.92-.66-1.39-1l-.52-.32c-.3-.19-.61-.37-.92-.53l-.62-.32-.86-.41-.63-.28c-.3-.13-.61-.24-.92-.35l-.57-.21c-.46-.15-.92-.29-1.38-.41l-.71-.16-.77-.16-.77-.12-.71-.08-.79-.07-.68,0-.79,0q-.65,0-1.3.06h0c-10.23.84-19.19,9.77-19.19,24V655h16v5.34a16.59,16.59,0,0,0-9.64,15.05v45.51l-13.58,62.39H489l-2.67,11.91,19.16,3.1h0l.83.13c2-.86-1.35-4.89-2.86-8a8.54,8.54,0,0,1-.4-1,7.57,7.57,0,0,1-.38-1.94L517.4,739.2l-.07,0,.35-1.13s18.74,8,23.56,24.09c3.91,13,1.48,21.46.42,24.2h-.07v.16c-.21.52-.36.81-.36.81h.36v8.83h20.26c1.88-.95-2.11-3.72-4.1-6a5.67,5.67,0,0,1-1.32-2.55h.34l.16-.72a69.53,69.53,0,0,0-20.86-65.77.77.77,0,0,0,.09-.17,74.45,74.45,0,0,0,3.51-18.06c15.49,1.48,36.1.42,51.51-11.52a48,48,0,0,0,4.21-3.58c1.33-.1,3.66-.84,4.95-4.6a6.42,6.42,0,0,0,.24-.94c0-.1,0-.2,0-.29A5.46,5.46,0,0,0,600.65,681.32Z",
    transform: "translate(-154.5 -94.48)",
    fill: "url(#2b699f83-9fbb-4b6d-8a24-a3f0d4476570)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M519.49,698.94s46.9,14.91,72.88-10l-5.51-7.21s-50.4,11.23-62.41,3S519.49,698.94,519.49,698.94Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#6415ff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M591.05,688l.92,1.2c-26,24.92-72.88,10-72.88,10s-.12-.38-.3-1C524.38,699.87,566.81,711.28,591.05,688Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M591.37,688.93s3.84.87,5.61-4.28-4.4-7.42-4.4-7.42-6.43,2.37-6.41,4.89S591.37,688.93,591.37,688.93Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#985454"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M590.76,688.12s3.84.87,5.61-4.28a4.83,4.83,0,0,0-.45-4.36,4.9,4.9,0,0,1,1.06,5.16c-1.77,5.16-5.61,4.28-5.61,4.28a27.32,27.32,0,0,1-4.12-4.31A29.83,29.83,0,0,0,590.76,688.12Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "4635430b-7803-4f1f-9770-b56b2b482545",
    "data-name": "<Path>",
    d: "M541.7,781.75h13.89a4.56,4.56,0,0,0,1.31,3.57c1.87,2.16,5.63,4.77,3.86,5.66H541.7Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#6415ff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M555.89,785.32a4.56,4.56,0,0,1-1.31-3.57h1a4.56,4.56,0,0,0,1.31,3.57c1.87,2.16,5.63,4.77,3.86,5.66h-1C561.52,790.09,557.76,787.49,555.89,785.32Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "a892faa3-7b18-4010-9d55-72c2aac7ddb8",
    "data-name": "<Path>",
    d: "M492.23,778.89l13,2.13a6.62,6.62,0,0,0,.59,4.58c1.42,3,4.61,6.74,2.69,7.55l-18.82-3Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#6415ff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M504.83,785.59a6.62,6.62,0,0,1-.59-4.58l-12.05-2,0-.16,13,2.13a6.62,6.62,0,0,0,.59,4.58c1.42,3,4.61,6.74,2.69,7.55l-.79-.13C509.16,792,506.19,788.41,504.83,785.59Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 514.15,
    y: 650.64,
    width: 14.11,
    height: 20.91,
    rx: 7.06,
    ry: 7.06,
    transform: "translate(887.91 1227.71) rotate(180)",
    fill: "#985454"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.45,
    cy: 547.85,
    r: 15.62,
    fill: "#985454"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M526.5,664.5v-6.8a7,7,0,0,0-.16-1.48,15.62,15.62,0,0,0-6.26-29.49l.88,0a15.62,15.62,0,0,1,7.15,29.51,7,7,0,0,1,.16,1.48v6.8a7,7,0,0,1-7.94,7A7.08,7.08,0,0,0,526.5,664.5Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M505.08,720.18s30.13,3.4,31.24,0c7.81-23.94,0-42.83,0-42.83a15.62,15.62,0,0,0-15.62-15.62h0a15.62,15.62,0,0,0-15.62,15.62Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#6415ff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M505.08,720.18l-13.61,62.49h13.61l14.11-46.36s17.64,7.56,22.17,22.68,0,23.68,0,23.68H556l.15-.68a65,65,0,0,0-19.8-61.81h0",
    transform: "translate(-154.5 -94.48)",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M534.56,720.18c7.81-23.94,0-42.83,0-42.83a15.62,15.62,0,0,0-14.61-15.59c.33,0,.67,0,1,0h0a15.62,15.62,0,0,1,15.62,15.62s7.81,18.9,0,42.83c-.4,1.22-4.52,1.56-9.64,1.51C531.09,721.63,534.22,721.23,534.56,720.18Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.93,737.41l-13.85,45.51h-2l14.11-46.36S517.84,736.84,518.93,737.41Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.31,720.43h2a65,65,0,0,1,19.8,61.81l-.15.68h-2l.15-.68A65,65,0,0,0,534.31,720.43Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M517.49,688.94s46.9,14.91,72.88-10l-5.51-7.21s-50.4,11.23-62.41,3S517.49,688.94,517.49,688.94Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#6415ff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M589.05,678l.92,1.2c-26,24.92-72.88,10-72.88,10s-.12-.38-.3-1C522.38,689.87,564.81,701.28,589.05,678Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M589.37,678.93s3.84.87,5.61-4.28-4.4-7.42-4.4-7.42-6.43,2.37-6.41,4.89S589.37,678.93,589.37,678.93Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#985454"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M588.76,678.12s3.84.87,5.61-4.28a4.83,4.83,0,0,0-.45-4.36,4.9,4.9,0,0,1,1.06,5.16c-1.77,5.16-5.61,4.28-5.61,4.28a27.32,27.32,0,0,1-4.12-4.31A29.83,29.83,0,0,0,588.76,678.12Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M522.12,637.15l-1,21h-22V647c0-22.39,23.67-30.89,37-12.9C536.45,634.59,522.12,637.15,522.12,637.15Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M517.18,624.49c5.61.46,11.38,3.52,15.94,9.67.33.44-14,3-14,3l-1,21h3l1-21s14.33-2.56,14-3C530.75,626.9,523.69,624,517.18,624.49Z",
    transform: "translate(-154.5 -94.48)",
    fill: "#fff",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIllustration);
export default __webpack_public_path__ + "static/media/stats-illustration.89e20edcbf2cccadc1f28b4a73a486ac.svg";
export { ForwardRef as ReactComponent };